export default __webpack_public_path__ + "static/media/connecting_generating_path.dcebeb5f.gif";